import PropTypes from 'prop-types'
import SearchCityResultPage from '@layouts/courses/city'
import Error from '@components/error'

const CityCoursesPage = ({ query, query: { city, state } }) => {
  return (
    city && state ? <SearchCityResultPage query={query} /> : <Error statusCode={404} />
  )
}

CityCoursesPage.getInitialProps = async ({ query }) => ({ query })

CityCoursesPage.propTypes = {
  query: PropTypes.object,
}

export default CityCoursesPage
